<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left></vdr-ab-left>
    <vdr-ab-right>
      <vdr-action-bar-items
        [locationId]="'request-refund-list'"
      ></vdr-action-bar-items>
      <button
        class="button primary"
        (click)="bulkApprove()"
        [disabled]="selectionManager.selection.length <= 0"
        style="margin-right: 1rem"
      >
        {{ "common.approve" | translate }}
      </button>
      <button
        class="button danger"
        (click)="bulkReject()"
        [disabled]="selectionManager.selection.length <= 0"
      >
        {{ "common.reject" | translate }}
      </button>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>
<vdr-data-table-2
  id="review-list"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="refund-list"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  />

  <vdr-dt2-column
    id="id"
    [heading]="'common.id' | translate"
    [hiddenByDefault]="true"
  >
    <ng-template let-refundReq="item">
      {{ refundReq.id }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="createdAt"
    [heading]="'common.created-at' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-refundReq="item">
      {{ refundReq.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="updatedAt"
    [heading]="'common.updated-at' | translate"
    [hiddenByDefault]="true"
  >
    <ng-template let-refundReq="item">
      {{ refundReq.updatedAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="customer"
    [heading]="'common.customer' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-refundReq="item">
      <a
        class="button-ghost"
        [routerLink]="['/extensions/ui-customer', refundReq.order.customer.id]"
      >
        <span>
          {{ refundReq.order.customer.firstName }}
        </span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="requester"
    [heading]="'common.requester' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-refundReq="item">
      <vdr-chip>
        {{ refundReq.type }}
      </vdr-chip>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="orderNumber"
    [heading]="'common.orderNumber' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-refundReq="item">
      <a class="button-ghost" [routerLink]="['/orders', refundReq.orderId]">
        <span>
          {{ refundReq.order.code }}
        </span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="status"
    [heading]="'common.status' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-refundReq="item">
      <vdr-chip [colorType]="refundReq.status | statusColor">
        {{ refundReq.status }}
      </vdr-chip>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="paymentMethod"
    [heading]="'common.paymentMethod' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-refundReq="item">
      {{ refundReq.payment.method }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="paymentAmount"
    [heading]="'common.paymentAmount' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-refundReq="item">
      <!-- {{
        refundReq.payment.amount | localeCurrency : refundReq.order.currencyCode
      }} -->
      {{ getOrderTotal(refundReq) }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="refundQuan"
    [heading]="'common.quantity' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-refundReq="item">
      {{ getQuantity(refundReq) }} {{ "common.items" | translate }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="view"
    [heading]="'common.action' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-refundReq="item">
      <button
        [style.background-color]="
          refundReq.status === 'approved' ? '#008DDA' : 'white'
        "
        [style.color]="refundReq.status === 'approved' ? 'white' : '#666666'"
        class="button-ghost"
        (click)="viewDetail(refundReq)"
      >
        <span>{{ "common.view" | translate }}</span>
        <clr-icon shape="arrow right"></clr-icon>
      </button>
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
